import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosProgressEvent } from "axios";
import { updateImageProgress } from "../features/modelSlice";
import BaseUrl from "@/BaseUrl";

export const uploadImageWithProgress = createAsyncThunk(
  "images/uploadWithProgress",
  async (
    { id, file }: { id: string; file: File },
    { dispatch, rejectWithValue }
  ) => {
    const formData = new FormData();
    formData.append("url", file);

    try {
      const response = await axios.post(
        `${BaseUrl()}/api/style/v1/photo-upload/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          onUploadProgress: (event: AxiosProgressEvent) => {
            const progress = Math.round(
              ((event?.loaded ?? 0) * 100) / (event?.total ?? 1)
            );
            dispatch(updateImageProgress({ id, progress }));
          },
        }
      );

      return { id, url: response.data.url };
    } catch (error) {
      return rejectWithValue({ id, error: (error as Error).message });
    }
  }
);

export const fetchImages = createAsyncThunk("images/fetch", async () => {
  const response = await axios.get(`${BaseUrl()}/api/style/v1/photo-list/`, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
  });
  return response.data.data;
});

export const deleteImage = createAsyncThunk(
  "images/delete",
  async (id: string) => {
    await axios.delete(`${BaseUrl()}/api/style/v1/photo-soft-delete/${id}/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    });
    return id;
  }
);
